import { CountriesEnum, ModuleEnum, DesignEnum } from '../generated/operations';
import { I18N } from '../types/I18N';

export const NULL_STRING = 'NULL';
export const DEFAULT_COUNTRY = CountriesEnum.Ch;
export const LABEL_FIELD_NAME = 'label';
export const USER_SETTINGS = 'UserSettings';
export const ENABLE_OFFLINE = 'EnableOffline';
export const CONFIG_KEY = 'Config';
export const DATABASE_KEY = 'RetrofitDB';
export const DATABASE_CACHE_KEY = 'DatabaseCache';
export const FEEDBACK_STATE = 'FeedbackState';
export const FEEDBACK_VISIT_THRESHOLD = 10;

export const NUMERIC_ATTRIBUTE_NAMES = [
  //valves
  'kvs',
  'dn',
  'closeOffPressure',
  //actuators
  'torque',
  'stroke',
  'actuatingForce',
  'runningTime',
  // sensors
  'probeLength'
];

export enum PATH {
 FIND_BY_DESIGN = 'design',
 FIND_BY_DESIGN_MOBILE = 'designMobile',
 DETAILS = 'details',
 FILTER = 'filter',
 FILTER_VALUES = 'values',
 VALVES_TAB = 'valves',
}

export enum CONSTANTS {
  RETROFIT_AIR = 'RetroFIT+ Air',
  RETROFIT_WATER = 'RetroFIT+ Water',
  RETROFIT_SENSOR = 'RetroFIT+ Sensor',
  RETROFIT_AIR_OLD = 'Retrofit Air',
  RETROFIT_WATER_OLD = 'Retrofit Water',
  RETROFIT_SENSOR_OLD = 'Retrofit Sensor',
  ACTUATOR = 'Actuator',
  VALVE = 'Valve',
  VALVE_ACTUATOR_UNIT = 'Valve-actuator unit',
}

export const MESSAGES: I18N = {
  AirflowLowMetric: 'AirflowLowMetric',
  AirflowMidMetric: 'AirflowMidMetric',
  AirflowHighMetric: 'AirflowHighMetric',
  AirflowLabelMetric: 'AirflowLabelMetric',
  ChooseDamperType: 'ChooseDamperType',
  ChooseDamperBladeType: 'ChooseDamperBladeType',
  SIZE_YOU_DUMPER_LABEL: 'SIZE_YOU_DUMPER_LABEL',
  SIZE_YOU_DUMPER_NO_TORQUES_ERROR: 'SIZE_YOU_DUMPER_NO_TORQUES_ERROR',
  runningTimeFS: 'runningTimeFS',
  PoundInch: 'PoundInch',
  NewtonMeter: 'NewtonMeter',
  AirflowLabel: 'AirflowLabel',
  DamperBladeType: 'DamperBladeType',
  DamperType: 'DamperType',
  DamperRectangular: 'DamperRectangular',
  DamperRound: 'DamperRound',
  ParallelBladeWithSeals: 'ParallelBladeWithSeals',
  OpposedBladeWithSeals: 'OpposedBladeWithSeals',
  ParallelBladeWithoutSeals: 'ParallelBladeWithoutSeals',
  OpposedBladeWithoutSeals: 'OpposedBladeWithoutSeals',
  DamperDiameter: 'DamperDiameter',
  DamperWidth: 'DamperWidth',
  DamperHeight: 'DamperHeight',
  DamperArea: 'DamperArea',
  DamperRequiredForce: 'DamperRequiredForce',
  AirflowLow: 'AirflowLow',
  AirflowMid: 'AirflowMid',
  AirflowHigh: 'AirflowHigh',
  SquareFeet: 'SquareFeet',
  SquareMeter: 'SquareMeter',
  SIZE_YOUR_DAMPER: 'SIZE_YOUR_DAMPER',
  FireAndSmoke: 'FireAndSmoke',
  FIRE_AND_SMOKE_DAMPER_CALCULATOR: 'FIRE_AND_SMOKE_DAMPER_CALCULATOR',
  FIRE_AND_SMOKE_PNEUMATIC: 'FIRE_AND_SMOKE_PNEUMATIC',
  FIRE_AND_SMOKE_PNEUMATIC_DESCRIPTION: 'FIRE_AND_SMOKE_PNEUMATIC_DESCRIPTION',
  FIRE_AND_SMOKE_ELECTRONIC: 'FIRE_AND_SMOKE_ELECTRONIC',
  FIRE_AND_SMOKE_ELECTRONIC_DESCRIPTION: 'FIRE_AND_SMOKE_ELECTRONIC_DESCRIPTION',
  FIRE_AND_SMOKE_SELECT_TYPE: 'FIRE_AND_SMOKE_SELECT_TYPE',
  Accessory_Breadcrumb: 'Accessory_Breadcrumb',
  Accessory_Header: 'Accessory_Header',
  Accessory_Replacement_Header: 'Accessory_Replacement_Header',
  CABLE_LENGTH: 'CABLE_LENGTH',
  Ambient_Temperature: 'Ambient_Temperature',
  SEARCH : 'SEARCH',
  PRODUCT_NOT_FOUND : 'PRODUCT_NOT_FOUND',
  REPLACEMENT_NOT_FOUND : 'REPLACEMENT_NOT_FOUND',
  temperatureRating: 'temperatureRating',
  nominalVoltage : 'nominalVoltage',
  torque : 'torque',
  stroke : 'stroke',
  actuatingForce : 'actuatingForce',
  failSafeFunction : 'failSafeFunction',
  controlType : 'controlType',
  runningTime : 'runningTime',
  integratedSwitch : 'integratedSwitch',
  medium : 'medium',
  outputSignals : 'outputSignals',
  measuredValues : 'measuredValues',
  probeLength : 'probeLength',
  displayType : 'displayType',
  series : 'series',
  valveType : 'valveType',
  sensorType : 'sensorType',
  dn : 'dn',
  kvs : 'kvs',
  ACCESSORIES : 'ACCESSORIES',
  installationInstructions : 'installationInstructions',
  specification : 'specification',
  additionalFeatures : 'additionalFeatures',
  MEASURING_RANGES : 'MEASURING_RANGES',
  DEGREE_OF_PROTECTION_IECEN : 'DEGREE_OF_PROTECTION_IECEN',
  DEGREE_OF_PROTECTION_NEMAUL : 'DEGREE_OF_PROTECTION_NEMAUL',
  SEARCH_BY_PARAMETERS : 'SEARCH_BY_PARAMETERS',
  VIEW_LESS : 'VIEW_LESS',
  VIEW_MORE : 'VIEW_MORE',
  TECHNICAL_INFORMATION : 'TECHNICAL_INFORMATION',
  BUY_NOW : 'BUY_NOW',
  // filer values below
  company : 'company',
  Select : 'Select',
  NEW_VERSION_AVAILABLE : 'NEW_VERSION_AVAILABLE',
  RELOAD_NOW : 'RELOAD_NOW',
  SEARCH_BY_LABEL : 'SEARCH_BY_LABEL',
  SELECT_PRODUCT_TYPE : 'SELECT_PRODUCT_TYPE',
  SCAN : 'SCAN',
  AIR_REPLACEMENTS : 'AIR_REPLACEMENTS',
  SENSOR_REPLACEMENTS : 'SENSOR_REPLACEMENTS',
  WATER_REPLACEMENTS : 'WATER_REPLACEMENTS',
  ACTUATOR_SELECTED : 'ACTUATOR_SELECTED',
  VALVE_SELECTED : 'VALVE_SELECTED',
  SENSOR_SELECTED : 'SENSOR_SELECTED',
  SELECT_LOCALE : 'SELECT_LOCALE',
  RESULTS : 'RESULTS',
  ONE_TO_ONE : 'ONE_TO_ONE',
  SELECT_ACCESSORY_WARNING : 'SELECT_ACCESSORY_WARNING',
  HELP_TEXT_FOR_GLOBAL_SEARCH : 'HELP_TEXT_FOR_GLOBAL_SEARCH',
  CLEAR_ALL : 'CLEAR_ALL',
  SHOW : 'SHOW',
  CLEAR : 'CLEAR',
  S_DESCRIPTION : 'S_DESCRIPTION',
  F_DESCRIPTION : 'F_DESCRIPTION',
  H_DESCRIPTION : 'H_DESCRIPTION',
  D_DESCRIPTION : 'D_DESCRIPTION',
  B_DESCRIPTION : 'B_DESCRIPTION',
  H1_DESCRIPTION : 'H1_DESCRIPTION',
  H2_DESCRIPTION : 'H2_DESCRIPTION',
  LMIN_DESCRIPTION : 'LMIN_DESCRIPTION',
  DMAX_DESCRIPTION : 'DMAX_DESCRIPTION',
  A_DESCRIPTION : 'A_DESCRIPTION',
  C_DESCRIPTION : 'C_DESCRIPTION',
  M_DESCRIPTION : 'M_DESCRIPTION',
  SEARCH_RESULTS : 'SEARCH_RESULTS',
  CONTACT_MANUFACTURER : 'CONTACT_MANUFACTURER',
  WE_RE_SORRY : 'WE_RE_SORRY',
  WE_WERE_NOT_ABLE_TO_FIND_MATCH : 'WE_WERE_NOT_ABLE_TO_FIND_MATCH',
  OCR_CAN_NOT_PROVIDE_RESULTS : 'OCR_CAN_NOT_PROVIDE_RESULTS',
  FOUND_OCR_LABELS : 'FOUND_OCR_LABELS',
  ERROR_TITLE : 'ERROR_TITLE',
  UNRECOVERABLE_ERROR_MESSAGE : 'UNRECOVERABLE_ERROR_MESSAGE',
  NO_NETWORK_ERROR_MESSAGE: 'NO_NETWORK_ERROR_MESSAGE',
  SHOW_ACCESSORIES : 'SHOW_ACCESSORIES',
  HIDE_ACCESSORIES : 'HIDE_ACCESSORIES',
  PRODUCT_NAME : 'PRODUCT_NAME',
  HUMIDITY : 'HUMIDITY',
  CO2 : 'CO2',
  VOC : 'VOC',
  TEMPERATURE : 'TEMPERATURE',
  PRESSURE : 'PRESSURE',
  FIND_BY_DESIGN_HEADLINE : 'FIND_BY_DESIGN_HEADLINE',
  D_MAX_DESCRIPTION : 'D_MAX_DESCRIPTION',
  SELECT_ACCESSORY_WARNING_AIR : 'SELECT_ACCESSORY_WARNING_AIR',
  ALL_COMPANIES : "ALL_COMPANIES",
  INVALID_NUMBER : 'INVALID_NUMBER',
  INVALID_COUNTRY_CODE : 'INVALID_COUNTRY_CODE',
  TOO_SHORT : 'TOO_SHORT',
  TOO_LONG : 'TOO_LONG',
  CHOOSE_CATEGORY : 'CHOOSE_CATEGORY',
  CATEGORY : 'CATEGORY',
  PHOTO : 'PHOTO',
  EMAIL : 'EMAIL',
  PHONE : 'PHONE',
  DESCRIPTION : 'DESCRIPTION',
  SAVE : 'SAVE',
  CANCEL : 'CANCEL',
  REQUEST_BEFORE_TEXT : 'REQUEST_BEFORE_TEXT',
  REQUEST_NEW_PRODUCT : 'REQUEST_NEW_PRODUCT',
  FILE_SELECTED : 'FILE_SELECTED',
  FILE_TITLE : 'FILE_TITLE',
  REQUEST_PRODUCT_FORM_TITLE : 'REQUEST_PRODUCT_FORM_TITLE',
  REQUEST_PRODUCT_FORM_SUBTITLE : 'REQUEST_PRODUCT_FORM_SUBTITLE',
  REQUIRED : 'REQUIRED',
  REQUEST_PRODUCT_FORM_DESCRIPTION_PLACEHOLDER : 'REQUEST_PRODUCT_FORM_DESCRIPTION_PLACEHOLDER',
  REQUEST_PRODUCT_FORM_FIRST_NAME : 'REQUEST_PRODUCT_FORM_FIRST_NAME',
  REQUEST_PRODUCT_FORM_LAST_NAME : 'REQUEST_PRODUCT_FORM_LAST_NAME',
  REQUEST_PRODUCT_FORM_COMPANY : 'REQUEST_PRODUCT_FORM_COMPANY',
  REQUEST_PRODUCT_FORM_SALUTATION : 'REQUEST_PRODUCT_FORM_SALUTATION',
  REQUEST_PRODUCT_FORM_MALE : 'REQUEST_PRODUCT_FORM_MALE',
  REQUEST_PRODUCT_FORM_FEMALE : 'REQUEST_PRODUCT_FORM_FEMALE',
  REQUEST_PRODUCT_FORM_NO_INFO : 'REQUEST_PRODUCT_FORM_NO_INFO',
  REQUEST_PRODUCT_FORM_TEXT : 'REQUEST_PRODUCT_FORM_TEXT',
  REQUEST_PRODUCT_FORM_PRIVACY_POLICY : 'REQUEST_PRODUCT_FORM_PRIVACY_POLICY',
  FEEDBACK_FORM_TITLE : 'FEEDBACK_FORM_TITLE',
  FEEDBACK_FORM_DESCRIPTION : 'FEEDBACK_FORM_DESCRIPTION',
  FEEDBACK_FORM_DESCRIPTION_PLACEHOLDER : 'FEEDBACK_FORM_DESCRIPTION_PLACEHOLDER',
  FEEDBACK_FORM_HEADER : "FEEDBACK_FORM_HEADER",
  FEEDBACK_FORM_REASON_1: "FEEDBACK_FORM_REASON_1",
  FEEDBACK_FORM_REASON_2: "FEEDBACK_FORM_REASON_2",
  FEEDBACK_FORM_REASON_3: "FEEDBACK_FORM_REASON_3",
  FEEDBACK_FORM_REASON_4: "FEEDBACK_FORM_REASON_4",
  SUCCESS : "SUCCESS",
  FEEDBACK_FORM_SUCCESS_TEXT : "FEEDBACK_FORM_SUCCESS_TEXT",
  REQUEST_PRODUCT_FORM_SUCCESS_TEXT : "REQUEST_PRODUCT_FORM_SUCCESS_TEXT",
  FLOW : "FLOW",
  ACCURACY_FLOW : "ACCURACY_FLOW",
  ACCURACY_CO2 : "ACCURACY_CO2",
  ACCURACY_PRESSURE : "ACCURACY_PRESSURE",
  ACCURACY_TEMPERATURE : "ACCURACY_TEMPERATURE",
  CERTIFICATION : "CERTIFICATION",
  FITTING_LENGTH : "FITTING_LENGTH",
  G : "G",
  MEASURING_PRINCIPLE : "MEASURING_PRINCIPLE",
  VALVE_REPLACEMENTS : "VALVE_REPLACEMENTS",
  closeOffPressure : "closeOffPressure",
  valveNote : "valveNote",
  PN : "PN",
  FLUID_TEMPERATURE : "FLUID_TEMPERATURE",
  RP : "RP",
  FLANGE_TYPE : "FLANGE_TYPE",
  Find_by_Valve : "Find_by_Valve",
  BUTTERFLY_FLANGE_TYPE : "BUTTERFLY_FLANGE_TYPE",
  PIPE_CONNECTION : "PIPE_CONNECTION",
  VALVE_FAMILY_SHORT : "VALVE_FAMILY_SHORT",
  SELECT_UNIT: "SELECT_UNIT",
  mm: "mm",
  inch: "inch",
  inch_sign: "inch_sign",
  kvmax : "kvmax",
  vnomls : "vnomls",
  vnomlh : "vnomlh",
  DOWNLOAD_CENTER_LINK : "DOWNLOAD_CENTER_LINK",
  COUNTRY: "COUNTRY",
  VAU_REPLACEMENTS: "VAU_REPLACEMENTS",
  VAU_SELECTED: "VAU_SELECTED",
  vau: "vau",
  mountingType: "mountingType",
  kvssequence1: "kvssequence1",
  kvssequence2: "kvssequence2",
  cv: "cv",
  vnomgpm: "vnomgpm",
  cvsequence1: "cvsequence1",
  cvsequence2: "cvsequence2",
  BODY_PRESSURE_RATING: "BODY_PRESSURE_RATING",
  ACCURACY_HUMIDITY: "ACCURACY_HUMIDITY",
  DEGREE_OF_PROTECTION: "DEGREE_OF_PROTECTION",
  MULTIRANGE: "MULTIRANGE",
  SIZE_YOUR_DAMPER_LABEL: 'SIZE_YOUR_DAMPER_LABEL',
  FIRE_AND_SMOKE_PRODUCT_CROSS_REFERENCE: 'FIRE_AND_SMOKE_PRODUCT_CROSS_REFERENCE',
  FBD_Download_Info_Text: 'FBD_Download_Info_Text',
  FBD_Download_Info_Text_Mobile: 'FBD_Download_Info_Text_Mobile',
  FBD_Globe_Valve_Download: 'FBD_Globe_Valve_Download',
  FBD_Butterfly_Valve_Download: 'FBD_Butterfly_Valve_Download',
  FBD_Ball_Valve_Download: 'FBD_Ball_Valve_Download',
  FBD_Product_Not_Found_Description: 'FBD_Product_Not_Found_Description',
  FBD_Product_Not_Found_Download_Button: 'FBD_Product_Not_Found_Download_Button',
  FBD_Product_Not_Found_Upload_Description: 'FBD_Product_Not_Found_Upload_Description',
}


export const All_DESIGN_TYPES = [
  DesignEnum.Square,
  DesignEnum.Square45,
  DesignEnum.RotaryWedgeGroove,
  DesignEnum.RotaryFlatHead,
  DesignEnum.GlobeValve,
];

export const ALL_MODULES = [
  ModuleEnum.Air,
  ModuleEnum.Water,
  ModuleEnum.WaterByValve,
  ModuleEnum.Sensor,
  ModuleEnum.FireAndSmoke,
];

export const DELAY_FOR_CONTENT_RENDERING = 150;
export const COUNTRY_CODES_LOWERCASE = Object.values(CountriesEnum).map((v) => v.toLowerCase());
